/**
 * Created by dhbrown on 8/16/2022.
 */
define("torus/TorusMessager", [
    "jquery",
    "postal",
], function ($, postal) {
    TorusMessager = function () {
        var channel = postal.channel("logger");
        var subscriptions = [
            channel.subscribe("elementSelected", this.emitMessage.bind(this)),
            channel.subscribe("connectionMade", this.emitMessage.bind(this)),
            channel.subscribe("connectionBroken", this.emitMessage.bind(this)),
            channel.subscribe("componentAdded", this.emitMessage.bind(this)),
            channel.subscribe("componentsRemoved", this.emitMessage.bind(this)),
            channel.subscribe("selectionChanged", this.emitMessage.bind(this)),
            channel.subscribe("actionUsed", this.emitMessage.bind(this)),
            channel.subscribe("solutionChanged", this.emitMessage.bind(this)),
            channel.subscribe("update", this.emitMessage.bind(this))
        ];

    };
    TorusMessager.prototype.emitMessage = function () {
        window.parent.postMessage("vlabChanged", "*")
    }
    return TorusMessager;
});
